// product page accordian start
    
 // We use a self-invoking function to avoid global variable conflicts
(function() {
  const initAccordion = () => {
    const triggers = document.querySelectorAll('.js-accordion-trigger');
    
    triggers.forEach((trigger, index) => {
      // 1. Remove existing listener to prevent double-firing
      trigger.removeEventListener('click', toggleAccordion);
      trigger.addEventListener('click', toggleAccordion);

      // 2. Open the first accordion by default on initial load
      if (index === 0) {
        openAccordion(trigger);
      }
    });
  };

  // Helper function to open a specific accordion item
  function openAccordion(btn) {
    const contentId = btn.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    
    if (content) {
      btn.setAttribute('aria-expanded', 'true');
      content.classList.add('is-active');
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }

  function toggleAccordion(e) {
    const btn = e.currentTarget;
    const contentId = btn.getAttribute('aria-controls');
    const content = document.getElementById(contentId);
    const isExpanded = btn.getAttribute('aria-expanded') === 'true';

    // Toggle Attribute
    btn.setAttribute('aria-expanded', !isExpanded);

    if (content) {
      if (!isExpanded) {
        content.classList.add('is-active');
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.classList.remove('is-active');
        content.style.maxHeight = null;
      }
    }
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', initAccordion);
  
  // Shopify Theme Editor support
  document.addEventListener('shopify:block:select', initAccordion);
  document.addEventListener('shopify:block:deselect', initAccordion);
})();

// product page accordian end
